import React from "react";
import { APP_VERSION, BUILD_DATE } from "../../version";

export default function FooterAdmin({mainBackground}) {
  return (
    <>
      <footer className="block py-4">
        <div className="container mx-auto px-4">
          {/* <hr className="mb-4 border-b-1 border-blueGray-200" /> */}
          <div className="flex flex-wrap items-center justify-center">
            <div className="w-full text-center">
              <div className="text-sm text-gray-500 font-semibold py-1">
                Copyright © {new Date().getFullYear()}{" "}
                <a
                  // href="https://qtglobal.rw/"
                  href="https://ciichin.org/"
                  className="text-gray-500 hover:text-blueGray-700 text-sm font-semibold py-1"
                >
                  CIIC-HIN.
                </a>
                <div>
                  <span className="ml-2 text-primary text-xs">
                    {" "}
                    Version {APP_VERSION}
                  </span>
                </div>
              </div>
            </div>
            <div className="w-full md:w-8/12 px-4">
              <ul className="flex flex-wrap list-none md:justify-end  justify-center">
                {/* <li>
                  <a
                    href="https://qtglobal.rw/"
                    className="text-blueGray-600 hover:text-blueGray-800 text-sm font-semibold block py-1 px-3"
                  >
                    QT Global Software ltd.
                  </a>
                </li> */}
                {/* <li>
                  <a
                    href="https://qtglobal.rw/#about"
                    className="text-blueGray-600 hover:text-blueGray-800 text-sm font-semibold block py-1 px-3"
                  >
                    About Us
                  </a>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
